import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const esc = (s) =>
  String(s ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));

export const DOC_STYLES = {
  td: "padding:7px 10px;border-bottom:1px solid #E2E8F0;font-size:11.5px;color:#334155",
  tdNum: "padding:7px 10px;border-bottom:1px solid #E2E8F0;font-size:11.5px;text-align:right;font-family:'JetBrains Mono',monospace;color:#0F172A;font-weight:600",
  th: "padding:7px 10px;font-size:10px;color:#94A3B8;text-transform:uppercase;letter-spacing:1px;text-align:left;border-bottom:1px solid #CBD5E1",
  thNum: "padding:7px 10px;font-size:10px;color:#94A3B8;text-transform:uppercase;letter-spacing:1px;text-align:right;border-bottom:1px solid #CBD5E1",
};

export function docHeader(title, subtitle) {
  return `
    <div style="display:flex;align-items:center;justify-content:space-between">
      <div style="display:flex;align-items:center;gap:10px">
        <div style="width:34px;height:34px;border-radius:8px;background:#0F172A;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:15px;font-family:'General Sans',sans-serif">R</div>
        <div style="font-size:15px;font-weight:700;letter-spacing:3px;font-family:'General Sans',sans-serif">İRA FİNANS</div>
      </div>
      <div style="font-size:10px;color:#94A3B8;font-family:'JetBrains Mono',monospace">${esc(subtitle || "")}</div>
    </div>
    <div style="margin-top:4px;height:2px;background:#0F172A"></div>
    <div style="margin-top:18px;font-size:19px;font-weight:600;font-family:'General Sans',sans-serif">${esc(title)}</div>`;
}

export function signatureBlock({ docNo, userName, t }) {
  const dateStr = new Date().toLocaleString("tr-TR");
  return `
    <div style="margin-top:44px;display:flex;justify-content:space-between;align-items:flex-end">
      <div style="font-size:9.5px;color:#94A3B8;line-height:1.7;max-width:340px">
        ${esc(t.doc.eNote)}<br/>${esc(t.doc.no)}: <span style="font-family:'JetBrains Mono',monospace">${esc(docNo)}</span><br/>${dateStr}
      </div>
      <div style="text-align:center">
        <svg width="130" height="42" viewBox="0 0 130 42"><path d="M6 32 C 22 6, 34 46, 52 24 S 74 8, 88 24 S 108 34, 124 18" stroke="#0F172A" fill="none" stroke-width="1.6" stroke-linecap="round"/></svg>
        <div style="border-top:1px solid #0F172A;padding-top:5px;font-size:11px;font-weight:600;color:#0F172A">${esc(userName || "")}</div>
        <div style="font-size:9.5px;color:#94A3B8">${esc(t.doc.preparedBy)} / ${esc(t.doc.sign)}</div>
      </div>
    </div>`;
}

export function makeDocNo(prefix) {
  const d = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  const rand = Math.random().toString(16).slice(2, 6).toUpperCase();
  return `${prefix}-${d}-${rand}`;
}

export async function elementToPdf(innerHtml, filename) {
  const el = document.createElement("div");
  el.style.cssText = `position:fixed;left:-10000px;top:0;width:794px;background:#ffffff;padding:48px;font-family:'IBM Plex Sans',sans-serif;color:#0F172A`;
  el.innerHTML = innerHtml;
  document.body.appendChild(el);
  await new Promise((r) => setTimeout(r, 80));
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", logging: false });
  document.body.removeChild(el);

  const img = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "pt", "a4");
  const pw = pdf.internal.pageSize.getWidth();
  const ph = pdf.internal.pageSize.getHeight();
  const ih = (canvas.height * pw) / canvas.width;
  let pos = 0;
  let remaining = ih;
  pdf.addImage(img, "PNG", 0, pos, pw, ih);
  remaining -= ph;
  while (remaining > 0) {
    pos -= ph;
    pdf.addPage();
    pdf.addImage(img, "PNG", 0, pos, pw, ih);
    remaining -= ph;
  }
  pdf.save(filename);
}
